(() => {
  const params = new URLSearchParams(window.location.search);
  if (params.get('hhc_native_cart_preview') !== '1') return;

  document.documentElement.classList.add('hhc-native-cart-preview-active');

  function getNativeDrawer() {
    return document.querySelector('cart-drawer-component');
  }

  function openNativeDrawer() {
    const drawer = getNativeDrawer();
    if (!drawer) return;
    if (typeof drawer.open === 'function') {
      drawer.open();
      return;
    }
    // The custom element may not have finished upgrading yet (e.g. a click
    // fired immediately after page load, before cart-drawer.js registers
    // cart-drawer-component). Retry once the element is defined instead of
    // silently failing.
    customElements.whenDefined('cart-drawer-component').then(() => {
      getNativeDrawer()?.open();
    });
  }

  // Forces the native drawer open on any cart mutation while the preview
  // mode is active, independent of settings.auto_open_cart_drawer.
  document.addEventListener('cart:update', openNativeDrawer);

  // Captures the header cart-icon click before any other listener (e.g. a
  // third-party cart app) can intercept it, and calls the native component's
  // own public open() method directly instead of relying on event
  // propagation reaching Horizon's declarative on:click binding.
  document.addEventListener(
    'click',
    (event) => {
      const trigger = event.target.closest(
        'cart-drawer-component [aria-label*="panier" i], cart-drawer-component [aria-label*="cart" i]'
      );
      if (!trigger) return;
      openNativeDrawer();
    },
    true
  );
})();
